import { render } from "./BeerLogo.vue?vue&type=template&id=409e4118"
import script from "./BeerLogo.vue?vue&type=script&lang=js"
export * from "./BeerLogo.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__